import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { DangerButton, InfoButton, SuccessButton, WarningButton } from "../../../../ui/buttons/Button";
import { Checkbox, Input, SearchInput, Textarea } from "../../../../ui/inputs/Input";
import { Mensaje, MensajeSiNo2 } from "../../../mensajes2";
import { Dimmer } from "../../../spinner";
import CatalogoPersona from "../../../../catalogos/catalogoPersona";
import axios from "axios";
import { formatMoneda, validaSoloNumero } from "../../../../util/varios";
import CatalogoUbicacionBien from "../../../../catalogos/catalogoUbicacionBien";
import CatalogoIncorpBien from "../../../../catalogos/catalogoIncorpBien";
import CatalogoProveedor from "../../../../catalogos/catalogoProveedor";
import moment from "moment";
import CatalogoTransfMuebles from "../../../../catalogos/catalogoTransferenciaBienesMueble";
const op = require("../../../../modulos/datos");

export default function TransferenciaBienes({ show, setShow, setTabla, }) {
  const token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const btnTab1 = useRef();
  const btnTab2 = useRef();
  const btnTab3 = useRef();
  const btnTab4 = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtCodigoIncorporacion = useRef();
  const txtRif = useRef();
  const txtNombresApellidos = useRef();
  const txtIdtransferencia = useRef();
  const txtActual = useRef();
  const txtCodActivo = useRef();
  const txtCodOrden = useRef();
  const txtNumFactura = useRef();
  const txtCodProveedor = useRef();
  const txtIdUbicacion = useRef();
  const txtOriginal = useRef();
  const txtMas = useRef();
  const txtMenos = useRef();
  const txtCodigoBien = useRef();
  const txtMarca = useRef();
  const txtModelo = useRef();
  const txtAnio = useRef();
  const txtColor = useRef();
  const txtCapacidad = useRef();
  const txtTipo = useRef();
  const txtSeriales = useRef();
  const txtNumPieza = useRef();
  const txtPlaca = useRef();
  const txtAlto = useRef();
  const txtLargo = useRef();
  const txtAncho = useRef();
  const txtUso = useRef();
  const txtObservacion = useRef();
  const txtCodMotivo = useRef();
  const txtDescripcionMotivo = useRef();
  const txtValorInicial = useRef();
  const txtValorRescate = useRef();
  const txtDepresiacionMensual = useRef();
  const txtDepresiacionAcumulada = useRef();
  const txtValorLibros = useRef();
  const txtValorAdicion = useRef();
  const txtValorReexpresado = useRef();
  const txtCostoReposicion = useRef();
  const txtFecha = useRef();
  const txtFechaAdquisicion = useRef();
  const txtFechaTransferencia = useRef();
  const txtDescripUbicacion = useRef();
  const txtDireccionUbicacion = useRef();
  const txtRifP = useRef();
  const txtNombresApellidosP = useRef();
  const txtTipoMaterial = useRef();
  const txtDescripcionActivo = useRef();
  const txtIdUbicacionnew = useRef();
  const txtDescripUbicacionnew = useRef();
  const txtDireccionUbicacionnew = useRef();
  const txtRifNew = useRef();
  const txtNombresApellidosNew = useRef();
  const txtObservacionNew = useRef();
  const txtCargo = useRef();
  const txtCargo1 = useRef();
  const txtCodigoUbicacion = useRef();
  const txtCodigoUbicacionNew = useRef();

  const [operacion, setOperacion] = useState(0);
  const [tab, setTab] = useState(1);
  const [activate, setActivate] = useState(false);
  const [visibleButton, setVisibleButton] = useState(true);
  const [mostrarCatalogo3, setMostrarCatalogo3] = useState(true);
  const [valubi, setValubi] = useState(0);
  const [mostrarCatalogo, setMostrarCatalogo] = useState(false);
  const [mostrarCatalogo1, setMostrarCatalogo1] = useState(false);
  const [mostrarCatalogoResponsable, setMostrarCatalogoResponsable] = useState(false);
  const [mostrarCatalogoProveedor, setMostrarCatalogoProveedor] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const estilos = {
    tab: {
      borderBottomLeftRadius: 0.25,
      borderBottomRightRadius: 0.25,
      border: "solid rgba(5, 81, 130, 0.5)",
      borderBottom: "none",
    },
    contenido: {
      border: "solid rgba(5, 81, 130, 0.5)",
    },
  };

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  const onChangeValidar = async () => {
    let sigue = true;

    if (operacion !== 1 && txtIdtransferencia.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar la ubicacion.`,
        icono: "informacion",
      });
      setTab(1);
      sigue = false;
      txtIdtransferencia.current.focus();
    } else if (txtCodigoIncorporacion.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar el codigo del bien.`,
        icono: "informacion",
      });
      setTab(1);
      sigue = false;
      txtCodigoIncorporacion.current.focus();
    } else if (txtFechaTransferencia.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar la fecha de transferencia.`,
        icono: "informacion",
      });
      setTab(4);
      sigue = false;
      txtFechaTransferencia.current.focus();
    } else if (txtIdUbicacionnew.current.value === "" && txtCodigoUbicacionNew.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar la nueva ubicacion.`,
        icono: "informacion",
      });
      setTab(4);
      sigue = false;
      txtCodigoUbicacionNew.current.focus();
    } else if (txtRifNew.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `la nueva ubicacion no tiene un responsable asignado, por favor ingrese el numero de cedula/Rif del nuevo responsable o seleccione uno del catalogo.`,
        icono: "informacion",
      });
      setTab(4);
      sigue = false;
      txtRifNew.current.focus();
    } else if (txtObservacionNew.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar una observacion.`,
        icono: "informacion",
      });
      setTab(4);
      sigue = false;
      txtObservacionNew.current.focus();
    }

    if (sigue) {

      const datos = {
        operacion: operacion,
        nid: txtIdtransferencia.current.value === "" ? "0" : txtIdtransferencia.current.value.trim(),
        idincorp: txtCodigoIncorporacion.current.value.trim(),
        idubic: txtIdUbicacion.current.value.trim(),
        idubicnue: txtIdUbicacionnew.current.value.trim(),
        fec: moment(txtFechaTransferencia.current.value).format("DD-MM-YYYY"),
        cedresp: txtRif.current.value.trim(),
        nombresp: txtNombresApellidos.current.value.trim(),
        cargoresp: txtCargo.current.value.trim(),
        cedrespnue: txtRifNew.current.value.trim(),
        nombrespnue: txtNombresApellidosNew.current.value.trim(),
        cargorespnue: txtCargo1.current.value.trim(),
        obser: txtObservacionNew.current.value.trim().length > 700 ? txtObservacionNew.current.value.trim().substring(0, 699).toUpperCase() : txtObservacionNew.current.value.trim().toUpperCase(),
      };
      await procesarRegistro({
        datos: datos,
      });
    }
  };

  const procesarRegistro = async (body) => {
    setActivate(true);
    const endpoint = `${op.conexion}/api/bienes/transferenciainmueble/actualizar`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                response.data.transferenciamueble_act +
                " procesado correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                response.data.transferenciamueble_act +
                " modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                response.data.transferenciamueble_act +
                " eliminado correctamente",
              icono: "exito",
            });
          }
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response) {
          mensaje = error?.response?.data?.message;
        } else {
          mensaje = error.toString();
        }

        if (
          mensaje ===
          `duplicate key value violates unique constraint "ubicacionbien_pkey"`
        ) {
          mensaje = "Ya Existe una Ubicacion con ese codigo.";
        }

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarTransferencia = async (idubi) => {
    const campos = "*";
    const nomtab = "transferenciamueble";
    const nomid = "idtransferenciamueble";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${idubi}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            txtCodigoIncorporacion.current.value = data.idincorporacionmueble;
            txtFechaTransferencia.current.value = moment(data.fechatransferencia).format("YYYY-MM-DD");
            txtObservacionNew.current.value = data.observacion === null ? "" : data.observacion.trim();

            txtIdUbicacionnew.current.value = data.idubicacionbiennueva;
            txtIdUbicacion.current.value = data.idubicacionbien;
            txtRif.current.value = data.cedularesponsable;
            txtNombresApellidos.current.value = data.nombreresponsable === null ? "" : data.nombreresponsable.trim();
            txtCargo.current.value = data.cargoresponsable === null ? "" : data.cargoresponsable.trim();
            txtRifNew.current.value = data.cedularesponsablenuevo === null ? "" : data.cedularesponsablenuevo.trim();
            txtNombresApellidosNew.current.value = data.nombreresponsablenuevo === null ? "" : data.nombreresponsablenuevo.trim();
            txtCargo1.current.value = data.cargoresponsablenuevo === null ? "" : data.cargoresponsablenuevo.trim();

            await seleccionarBien(data.idincorporacionmueble);
            await seleccionarUbicacionNew(data.idubicacionbiennueva);
          } else {
            setActivate(false);
            txtRif.current.value = "";
            txtNombresApellidos.current.value = "";
            txtRif.current.focus();
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe un Responsable con este número de cédula/Rif.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarBien = async (idinco) => {
    const campos = "*";
    const nomtab = "incorporacionmueble";
    const nomid = "idincorporacionmueble";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${idinco}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            if (data.statusbien === 1 && operacion === 1) {
              setActivate(false);
              txtCodigoIncorporacion.current.value = "";
              btnTab1.current.disabled = false;
              btnTab2.current.disabled = true;
              btnTab3.current.disabled = true;
              btnTab4.current.disabled = true;
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Bien Mueble fue Desincorporado",
                icono: "informacion",
              });
            } else {
              btnTab1.current.disabled = false;
              btnTab2.current.disabled = false;
              btnTab3.current.disabled = false;
              btnTab4.current.disabled = false;
              txtCodigoIncorporacion.current.value = data.idincorporacionmueble;
              txtCodActivo.current.value = data.idtipoactivo;
              txtCodOrden.current.value = data.idordenpago;
              txtNumFactura.current.value = data.numfactura;
              txtCodProveedor.current.value = data.idproveedor;
              txtOriginal.current.value = parseInt(data.vidautiloriginal);
              txtMas.current.value = parseInt(data.vidautilmas);
              txtMenos.current.value = parseInt(data.vidautilmenos);
              txtActual.current.value = parseInt(data.vidautiloriginal) + parseInt(data.vidautilmas) - parseInt(data.vidautilmenos);
              txtCodigoBien.current.value = data.codigobien;
              txtMarca.current.value = data.marca;
              txtModelo.current.value = data.modelo;
              txtAnio.current.value = parseInt(data.anio);
              txtColor.current.value = data.color;
              txtCapacidad.current.value = data.capacidad;
              txtTipo.current.value = data.tipo;
              txtSeriales.current.value = data.seriales;
              txtNumPieza.current.value = parseInt(data.numpiezas);
              txtPlaca.current.value = data.placa;
              txtAlto.current.value = formatMoneda(data.alto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              txtLargo.current.value = formatMoneda(data.largo.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              txtAncho.current.value = formatMoneda(data.ancho.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              txtUso.current.value = data.uso;
              txtObservacion.current.value = data.observacionincorporacion;
              txtCodMotivo.current.value = data.idmotivoincorporacion;
              txtValorInicial.current.value = formatMoneda(data.valorinicial.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              txtValorRescate.current.value = formatMoneda(data.valorrescate.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              txtDepresiacionMensual.current.value = formatMoneda(data.depresiacionmensual.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              txtDepresiacionAcumulada.current.value = formatMoneda(data.depresiacionacumulada.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              txtValorLibros.current.value = formatMoneda(data.valorlibros.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              txtValorAdicion.current.value = formatMoneda(data.valoradicion.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              txtValorReexpresado.current.value = formatMoneda(data.valorreexpresado.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              txtCostoReposicion.current.value = formatMoneda(data.costoreposicion.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              txtFecha.current.value = moment(data.fechaincorporacion).format("YYYY-MM-DD");
              txtFechaAdquisicion.current.value = moment(data.fechaadquisicion).format("YYYY-MM-DD");
              if (data.idordenpago !== null) {
                await seleccionarOrdenPago(data.idordenpago);
              }
              if (operacion !== 1) {
                let idubiant = txtIdUbicacion.current.value;
                await seleccionarUbicacion(idubiant);
              } else {
                await seleccionarUbicacion(data.idubicacionbien);
              }
              await seleccionarRegistroMotivo(data.idmotivoincorporacion);
              await seleccionarRegistroTipoActivo(data.idtipoactivo);
            }
          } else {
            setActivate(false);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe un Bien Mueble con este número de código.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarOrdenPago = async (id) => {
    const endpoint = `${op.conexion}/api/bienes/transferenciainmueble/seleccionar_ordenpago?&idordenpago=${id}&idefiscal=${idefiscal}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            if (parseInt(data.reversado) === 1) {
              txtCodOrden.current.value = "";
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "La orden de pago fue reversada",
                icono: "informacion",
              });
              setActivate(false);
            } else {
              txtNumFactura.current.value = data.numfactura;
              txtCodProveedor.current.value = data.idproveedor;
              await seleccionarProveedor(data.idproveedor);
            }
          } else {
            setActivate(false);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe una Orden de Pago con este número de código.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarUbicacion = async (idubi) => {
    let campos = "*"
    let nomtab = "ubicacionbien";
    let condi = 'idubicacionbien = ' + idubi + ' AND ubicacionfisica = true';
    let orden = "idubicacionbien";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            let cod = data[0].codigoubicacion.substring(0, 2) + "-" + data[0].codigoubicacion.substring(2, 4) + "-" + data[0].codigoubicacion.substring(4, 6) + "-" + data[0].codigoubicacion.substring(6, 8);
            txtIdUbicacion.current.value = data[0].idubicacionbien;
            txtCodigoUbicacion.current.value = cod;
            txtDescripUbicacion.current.value = data[0].descripcionubicacionbien.trim() !== "" ? data[0].descripcionubicacionbien.trim() : "N/S";
            txtDireccionUbicacion.current.value = data[0].direccionubicacionbien.trim() !== "" ? data[0].direccionubicacionbien.trim() : "N/S";
            setValubi(1);
            await seleccionarResponsable(data[0].cedularesponsable, 1);
          } else {
            txtIdUbicacion.current.value = "";
            txtCodigoUbicacion.current.value = "";
            txtDescripUbicacion.current.value = "";
            txtDireccionUbicacion.current.value = "";
            setValubi(0);
            setActivate(false);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe una Ubicación con este número de código.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarUbicacionNew = async (idubi) => {
    let campos = "*"
    let nomtab = "ubicacionbien";
    let condi = 'idubicacionbien = ' + idubi + ' AND ubicacionfisica = true';
    let orden = "idubicacionbien";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            let cod = data[0].codigoubicacion.substring(0, 2) + "-" + data[0].codigoubicacion.substring(2, 4) + "-" + data[0].codigoubicacion.substring(4, 6) + "-" + data[0].codigoubicacion.substring(6, 8);
            if (cod !== txtIdUbicacion.current.value) {
              txtIdUbicacionnew.current.value = data[0].idubicacionbien;
              txtCodigoUbicacionNew.current.value = cod;
              txtDescripUbicacionnew.current.value = data[0].descripcionubicacionbien.trim() !== "" ? data[0].descripcionubicacionbien.trim() : "N/S";
              txtDireccionUbicacionnew.current.value = data[0].direccionubicacionbien.trim() !== "" ? data[0].direccionubicacionbien.trim() : "N/S";
              await seleccionarResponsable(data[0].cedularesponsable, 2);
            } else {
              txtIdUbicacionnew.current.value = "";
              txtCodigoUbicacionNew.current.value = "";
              txtDescripUbicacionnew.current.value = "";
              txtDireccionUbicacionnew.current.value = "";
              setActivate(false);
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "Debe Seleccionar una Ubicación Distinta a la Actual",
                icono: "informacion",
              });
            }
          } else {
            setActivate(false);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe una Ubicación con este número de código.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarResponsable = async (cedulares, tipo) => {
    const campos = "*";
    const nomtab = "persona";
    const nomid = "cedula";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${cedulares}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            if (tipo !== 2) {
              txtRif.current.value = data.cedula.trim();
              txtNombresApellidos.current.value = data.nombres.trim() + " " + data.apellidos.trim();
            } else {
              txtRifNew.current.value = data.cedula.trim();
              txtNombresApellidosNew.current.value = data.nombres.trim() + " " + data.apellidos.trim();
            }
            setActivate(false);
          } else {
            if (tipo !== 2) {
              txtRif.current.value = "";
              txtNombresApellidos.current.value = "";
              txtRif.current.focus();
            } else {
              txtRifNew.current.value = "";
              txtNombresApellidosNew.current.value = "";
              txtRifNew.current.focus();
            }
            setActivate(false);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe un Responsable con este número de cédula/Rif.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarProveedor = async (idproveedor) => {
    const campos = "*";
    const nomtab = "proveedor";
    const nomid = "idproveedor";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${idproveedor}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            txtRifP.current.value = data.rif.trim();
            txtNombresApellidosP.current.value = data.razonsocial.trim();
            setActivate(false);
          } else {
            setActivate(false);
            txtRifP.current.value = "";
            txtNombresApellidosP.current.value = "";
            txtRifP.current.focus();
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe un Proveedor con este número de cédula/Rif.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistroMotivo = async (idubi) => {
    const campos = "*";
    const nomtab = "motivoincorporacion";
    const nomid = "idmotivoincorporacion";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${idubi}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            txtDescripcionMotivo.current.value = data.descripcionincorporacion;
            setActivate(false);
          } else {
            setActivate(false);
            txtCodMotivo.current.value = "";
            txtDescripcionMotivo.current.value = "";
            txtCodMotivo.current.focus();
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe un Motivo de Incorporación con este número de código.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistroTipoActivo = async (idtipoactivo) => {
    const campos = "*";
    const nomtab = "tipoactivo";
    const nomid = "idtipoactivo";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${idtipoactivo}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            if (parseInt(data.tipobien) === 1) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El el tipo de activo no es mueble",
                icono: "informacion",
              });
            } else {
              txtDescripcionActivo.current.value = data.descripcion.trim();
              txtTipoMaterial.current.value = data.tipomaterial.trim();
            }
            setActivate(false);
          } else {
            setActivate(false);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El tipo de activo no Existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    btnTab1.current.disabled = true;
    btnTab2.current.disabled = true;
    btnTab3.current.disabled = true;
    btnTab4.current.disabled = true;
    txtIdtransferencia.current.value = "";
    txtCargo.current.value = "";
    txtCargo1.current.value = "";
    txtIdUbicacion.current.value = "";
    txtCodigoUbicacion.current.value = "";
    txtCodigoUbicacionNew.current.value = "";
    txtRif.current.value = "";
    txtNombresApellidos.current.value = "";
    txtCodigoIncorporacion.current.value = "";
    txtCodActivo.current.value = "";
    txtCodOrden.current.value = "";
    txtNumFactura.current.value = "";
    txtCodProveedor.current.value = "";
    txtOriginal.current.value = "";
    txtMas.current.value = "";
    txtMenos.current.value = "";
    txtCodigoBien.current.value = "";
    txtMarca.current.value = "";
    txtModelo.current.value = "";
    txtAnio.current.value = "";
    txtColor.current.value = "";
    txtCapacidad.current.value = "";
    txtTipo.current.value = "";
    txtSeriales.current.value = "";
    txtNumPieza.current.value = "";
    txtPlaca.current.value = "";
    txtAlto.current.value = "";
    txtLargo.current.value = "";
    txtAncho.current.value = "";
    txtUso.current.value = "";
    txtObservacion.current.value = "";
    txtCodMotivo.current.value = "";
    txtValorInicial.current.value = "0.00";
    txtValorRescate.current.value = "0.00";
    txtDepresiacionMensual.current.value = "0.00";
    txtDepresiacionAcumulada.current.value = "0.00";
    txtValorLibros.current.value = "0.00";
    txtValorAdicion.current.value = "0.00";
    txtValorReexpresado.current.value = "0.00";
    txtCostoReposicion.current.value = "0.00";
    txtFecha.current.value = "";
    txtFechaAdquisicion.current.value = "";
    txtActual.current.value = "";
    txtFechaTransferencia.current.value = "";
    txtDescripUbicacion.current.value = "";
    txtDireccionUbicacion.current.value = "";
    txtRifP.current.value = "";
    txtNombresApellidosP.current.value = "";
    txtTipoMaterial.current.value = "";
    txtDescripcionActivo.current.value = "";
    txtIdUbicacionnew.current.value = "";
    txtDescripUbicacionnew.current.value = "";
    txtDireccionUbicacionnew.current.value = "";
    txtRifNew.current.value = "";
    txtNombresApellidosNew.current.value = "";
    txtObservacionNew.current.value = "";
    txtDescripcionMotivo.current.value = "";
    setTab(1);
    setOperacion(0);
    setValubi(0);
    setMostrarCatalogo(false);
    setMostrarCatalogo1(false);
    setMostrarCatalogoResponsable(false);
    setMostrarCatalogoProveedor(false);
    setVisibleButton(true);
    setMostrarCatalogo3(false);
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setMensajesino({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setActivate(false);
  };

  const onClickButton = async (value) => {
    if (value === 1) {
      setTab(1);
      setOperacion(1);
      setMostrarCatalogo3(false);
      setVisibleButton(false);
    } else if (value === 2) {
      setTab(1);
      setOperacion(2);
      setMostrarCatalogo3(false);
      setVisibleButton(false);
    } else if (value === 3) {
      setTab(1);
      setOperacion(3);
      setMostrarCatalogo3(false);
      setVisibleButton(false);
    } else if (value === 4) {
      setTab(1);
      setOperacion(4);
      setMostrarCatalogo3(false);
      setVisibleButton(false);
    } else if (value === 5) {
      setVisibleButton(false);
      await onChangeValidar();
    } else if (value === 6) {
      blanquear();
    } else if (value === 7) {
      imprimirTransferencias();
    }
  };

  const onHideUbicacion = (value) => {
    setMostrarCatalogo(false);
    txtIdUbicacionnew.current.value = value;
    seleccionarUbicacionNew(value);
  };

  const onHideIncorpBien = (value) => {
    setMostrarCatalogo1(false);
    if (value) {
      txtCodigoIncorporacion.current.value = value;
      seleccionarBien(value);
    }
  };

  const onHideResponsalbe = (value) => {
    setMostrarCatalogoResponsable(false);
    if (value) {
      txtRif.current.value = value;
      seleccionarResponsable(value);
    }
  };

  const onHideProveedor = (value) => {
    setMostrarCatalogoResponsable(false);
    if (value) {
      txtRifP.current.value = value;
      seleccionarProveedor(value);
    }
  };

  const onHideTransferenciaBien = (value) => {
    setMostrarCatalogo3(false);
    if (value) {
      txtIdtransferencia.current.value = value;
      seleccionarTransferencia(value);
    }
  };

  const imprimirTransferencias = () => {
    const reporte = "ListTrasferencias";
    const dolar = 0.0;
    const bolivar = 0.0;
    const sql = "'" + txtIdtransferencia.current.value + "'";
    const sql2 = dolar.toString();
    const sql3 = bolivar.toString();
    const titulo = "TRANSFERENCIA DE BIENES MUEBLES";

    console.log(sql);

    window.open(
      op.reportes +
      "/bienes?" +
      "reporte=" +
      reporte +
      "&ID=" +
      sql +
      "&DOLAR=" +
      sql2 +
      "&BOLIVAR=" +
      sql3 +
      "&TITULO=" +
      titulo,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  return (
    <Modal size="xl" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Transferencia de Bienes - Inmuebles</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body style={{ height: 450, overflow: "auto" }}>

        <ul className="nav nav-tabs mb-2" id="nav-tab" role="tablist">
          <li className="nav-item " role="presentation" onClick={() => setTab(1)}>
            <button
              className="nav-link text-white rounded p-2 bg-primary"
              style={tab === 1 ? estilos.tab : {}}
              ref={btnTab1}
              disabled
            >
              <i className="fas mx-2 fa-folder-minus"></i>Datos Generales
            </button>
          </li>
          <li className="nav-item " role="presentation" onClick={() => setTab(2)}>
            <button
              className="nav-link text-white rounded p-2 bg-primary"
              style={tab === 2 ? estilos.tab : {}}
              ref={btnTab2}
              disabled
            >
              <i className="fas mx-2 fa-folder-minus"></i>Características del Inmueble
            </button>
          </li>
          <li className="nav-item " role="presentation" onClick={() => setTab(3)}>
            <button
              className="nav-link text-white rounded p-2 bg-primary"
              style={tab === 3 ? estilos.tab : {}}
              ref={btnTab3}
              disabled
            >
              <i className="fas mx-2 fa-folder-minus"></i>Costos
            </button>
          </li>
          <li className="nav-item " role="presentation" onClick={() => setTab(4)}>
            <button
              className="nav-link text-white rounded p-2 bg-primary"
              style={tab === 4 ? estilos.tab : {}}
              ref={btnTab4}
              disabled
            >
              <i className="fas mx-2 fa-folder-minus"></i> Datos de la Transferencia
            </button>
          </li>
        </ul>
        <div className="tab-content mt-2" id="nav-tabContent">
          <div
            hidden={tab !== 1}
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <input type="hidden" ref={txtCargo} value={""} />
              <input type="hidden" ref={txtCargo1} value={""} />
              <div className="col-2 m-0 mb-2 p-0">
                <SearchInput
                  ref={txtIdtransferencia}
                  disabled
                  label="CÓDIGO:"
                  name="id"
                  onClickButton={() => setMostrarCatalogo3(true)}
                  disabledButton={operacion === 0 || operacion === 1 ? true : false}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <SearchInput
                  ref={txtCodigoIncorporacion}
                  disabled
                  label="CÓDIGO BIEN:"
                  name="idbien"
                  onClickButton={() => setMostrarCatalogo1(true)}
                  disabledButton={operacion === 1 ? false : true}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Id. Tipo Activo:" ref={txtCodActivo} name="idtipoactivo" disabled />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Input label="Descripción:" ref={txtDescripcionActivo} disabled />
              </div>
              <div className="col-9 m-0 p-0">
                <Input label="Tipo Material:" ref={txtTipoMaterial} disabled />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input label="Fecha Incorporación:" ref={txtFecha} disabled type="date" />
              </div>
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos Orden Pago
                </legend>
                <div className="col-3 m-0 mb-2 p-0">
                  <Input label="Cod. Orden Pago:" ref={txtCodOrden} disabled />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input label="Factura:" ref={txtNumFactura} disabled />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input label="Fecha Adquisición:" ref={txtFechaAdquisicion} type="date" disabled />
                </div>
                <div className="col-12 m-0 p-0 d-flex flex-wrap">
                  <div className="col-3 m-0 p-0">
                    <Input label="Cod. Proveedor:" ref={txtCodProveedor} disabled />
                  </div>
                  <div className="col-3 m-0 p-0 pl-2">
                    <Input label="C.I. / RIF:" ref={txtRifP} disabled />
                  </div>
                  <div className="col-6 m-0 p-0 pl-2">
                    <Input label="Nombre / Razón Social:" ref={txtNombresApellidosP} disabled />
                  </div>
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos de la Ubicación
                </legend>
                <div className="col-3 m-0 p-0">
                  <Input
                    ref={txtCodigoUbicacion}
                    disabled
                    label="CÓD UBICACIÓN:"
                    name="idubicacion"
                  />
                  <input type="hidden" ref={txtIdUbicacion} />
                </div>
                <div className="col-4 m-0 p-0 pl-2">
                  <Input label="Descripción:" ref={txtDescripUbicacion} disabled />
                </div>
                <div className="col-5 m-0 p-0 pl-2">
                  <Input label="Dirección:" ref={txtDireccionUbicacion} disabled />
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos Vida Útil
                </legend>
                <div className="col-3 m-0 p-0">
                  <Input label="Original:" ref={txtOriginal} disabled />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input label="+" ref={txtMas} disabled />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input label="-" ref={txtMenos} disabled />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input label="Actual:" ref={txtActual} disabled />
                </div>
              </fieldset>
            </div>
          </div>
          <div
            hidden={tab !== 2}
          >
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos del Mueble
              </legend>
              <div className="col-12 m-0 mb-2 p-0">
                <div className="col-5 m-0 p-0">
                  <Input label="Código Bienes Nacionales:" ref={txtCodigoBien} disabled />
                </div>
              </div>
              <div className="col-5 m-0 mb-2 p-0">
                <Input label="Marca:" ref={txtMarca} disabled />
              </div>
              <div className="col-5 m-0 mb-2 p-0 pl-2">
                <Input label="Modelo:" ref={txtModelo} disabled />
              </div>
              <div className="col-2 m-0 mb-2 p-0 pl-2">
                <Input label="Año:" ref={txtAnio} disabled />
              </div>
              <div className="col-5 m-0 mb-2 p-0">
                <Input label="Color:" ref={txtColor} disabled />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Capacidad:" ref={txtCapacidad} disabled />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Input label="Tipo:" ref={txtTipo} disabled />
              </div>
              <div className="col-5 m-0 mb-2 p-0">
                <Input label="Seriales:" ref={txtSeriales} disabled />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Numero de Piezas:" ref={txtNumPieza} disabled />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Input label="Placa:" ref={txtPlaca} disabled />
              </div>
              <div className="col-6 m-0 p-0">
                <Input label="Uso:" ref={txtUso} disabled />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Input label="Alto:" ref={txtAlto} disabled />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Input label="Largo:" ref={txtLargo} disabled />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Input label="Ancho:" ref={txtAncho} disabled />
              </div>
              <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
                <legend className="float-none w-auto m-0">Disposición</legend>
                <div className="col-3 m-0 p-0">
                  <Input label="Cod. Motivo:" ref={txtCodMotivo} disabled />
                </div>
                <Input label="Descripción:" ref={txtDescripcionMotivo} disabled />
              </fieldset>
              <div className="col-12 m-0 mt-2 p-0">
                <Textarea label="Observación:" ref={txtObservacion} style={{ height: 70 }} disabled />
              </div>
            </fieldset>
            <fieldset className="col-12 m-0 p-2 d-flex gap-2  border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos del Responsable Patrimonial
              </legend>
              <div className="col-3 m-0 p-0">
                <Input label=" Cédula de Identidad:" ref={txtRif} disabled />
              </div>
              <Input label="Nombre del Responsable:" ref={txtNombresApellidos} disabled />
            </fieldset>
          </div>
          <div
            hidden={tab !== 3}
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-3 m-0 mb-2 p-0">
                <Input
                  label="Valor Inicial:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  disabled
                  ref={txtValorInicial}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Valor Rescate:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  disabled
                  ref={txtValorRescate}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Depressiación Mensual:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  disabled
                  ref={txtDepresiacionMensual}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Depresiación Acumulada:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  disabled
                  ref={txtDepresiacionAcumulada}
                />
              </div>
              <div className="col-3 m-0 p-0">
                <Input
                  label="Valor Libros:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  disabled
                  ref={txtValorLibros}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Valor Adición:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  disabled
                  ref={txtValorAdicion}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Valor Reexpresado:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  disabled
                  ref={txtValorReexpresado}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Costo Reposición:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  disabled
                  ref={txtCostoReposicion}
                />
              </div>
            </div>
          </div>
          <div
            hidden={tab !== 4}
          >
            <fieldset className="col-12 m-0 p-2 border-azul rounded">
              <legend className="float-none w-auto m-0">Datos Transferencia</legend>
              <div className="col-3 m-0 p-0">
                <Input label='Fecha de Transferencia:' inputClassName="px-1" ref={txtFechaTransferencia} type='date' disabled={operacion === 1 || operacion === 2 ? false : true} />
              </div>
              <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                <legend className="float-none w-auto m-0">Datos de la Nueva Ubicación</legend>
                <div className="col-3 m-0 p-0">
                  <SearchInput
                    ref={txtCodigoUbicacionNew}
                    disabled
                    label="CÓD UBICACIÓN:"
                    name="id"
                    onClickButton={() => setMostrarCatalogo(true)}
                    disabledButton={operacion === 1 && valubi === 1 || operacion === 2 && valubi === 1 ? false : true}
                  />
                  <input type="hidden" ref={txtIdUbicacionnew} />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input label='Descripción:' ref={txtDescripUbicacionnew} disabled />
                </div>
                <div className="col-6 m-0 p-0 pl-2">
                  <Input label='Dirección:' ref={txtDireccionUbicacionnew} disabled />
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
                <legend className="float-none w-auto m-0">Datos del Nuevo Responsable Patrimonial</legend>
                <div className="col-3 m-0 p-0">
                  <Input label='Cédula de Identidad:' ref={txtRifNew} disabled />
                </div>
                <Input label='Nombre del Responsable:' ref={txtNombresApellidosNew} disabled />
              </fieldset>
              <div className="col-12 m-0 mt-2 p-0">
                <Textarea label='Observación:' ref={txtObservacionNew} disabled={operacion === 1 || operacion === 2 ? false : true} style={{ height: 70 }} />
              </div>
            </fieldset>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {visibleButton ? (
          <div className="col-12 d-flex m-auto justify-content-between">
            <SuccessButton onClick={() => onClickButton(1)} icon="fas fa-plus">
              Incluir
            </SuccessButton>
            <InfoButton onClick={() => onClickButton(4)} icon="fas fa-search">
              Consultar
            </InfoButton>
            <WarningButton onClick={() => onClickButton(2)} icon="fas fa-edit">
              Editar
            </WarningButton>
            <DangerButton onClick={() => onClickButton(3)} icon="fas fa-trash">
              Eliminar
            </DangerButton>
          </div>
        ) : (
          <div className="col-12 d-flex m-auto justify-content-end">
            <div className="m-1 p-0">
              <InfoButton
                icon="fas fa-print"
                disabled={operacion === 4 && valubi !== 0 ? false : true}
                onClick={() => onClickButton(7)}
              >
                Imprimir
              </InfoButton>
            </div>
            <div className="m-1 p-0">
              <SuccessButton
                disabled={operacion === 4 || valubi === 0 ? true : false}
                ref={btnAcepta}
                onClick={() => onClickButton(5)}
              >
                Aceptar
              </SuccessButton>
            </div>
            <div className="m-1 p-0">
              <DangerButton ref={btnCancela} onClick={() => onClickButton(6)}>
                Cancelar
              </DangerButton>
            </div>
          </div>
        )}
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />
      <MensajeSiNo2
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <CatalogoTransfMuebles
        show={mostrarCatalogo3}
        onHideCancelar={() => setMostrarCatalogo3(false)}
        onHideAceptaCatalogo={onHideTransferenciaBien}
      />
      <CatalogoUbicacionBien
        show={mostrarCatalogo}
        onHideCancelar={() => setMostrarCatalogo(false)}
        onHideAceptaCatalogo={onHideUbicacion}
      />
      <CatalogoIncorpBien
        show={mostrarCatalogo1}
        onHideCancelar={() => setMostrarCatalogo1(false)}
        onHideAceptaCatalogo={onHideIncorpBien}
      />
      <CatalogoPersona
        show={mostrarCatalogoResponsable}
        onHideCancelaCatPer={() => setMostrarCatalogoResponsable(false)}
        onHideAceptaCatPer={onHideResponsalbe}
      />
      <CatalogoProveedor
        show={mostrarCatalogoProveedor}
        onHideCancelaCatProv={() => setMostrarCatalogoProveedor(false)}
        onHideAceptaCatProv={onHideProveedor}
      />
    </Modal>
  );
}
